import { baseUrl, baseUrlName } from "./baseUrl";
import buildUrl from "../utils/buildUrl";

const billsBaseUrl = `${baseUrl}/billing-api`;

export const getBillsByAggIdRoute = (aggId) =>
  [billsBaseUrl, "bills", `search?agreementId=${aggId}`].join("/");

export const getBillsRoute = (...dirNames) => [billsBaseUrl, "bills", ...dirNames].join("/");

export const getBillsMassRoute = (params) =>
  buildUrl({
    url: `${baseUrl}/billing-api/bills/search`,
    searchParams: params,
  });

export const postBillRoute = () => [billsBaseUrl, "bills"].join("/");

export const getBillById = (billId) => [billsBaseUrl, "bills", `${billId}`].join("/");

export const postBillPrepaymentRoute = (date) =>
  [billsBaseUrl, "bills", "next", `period?onDate=${encodeURIComponent(date)}`].join("/");

export const getBillsSearchRoute = (searchParam) => {
  const searchString = Object.entries(searchParam)
    .filter(([, value]) => Boolean(value))
    .map(([param, value]) => `${param}=${value}`)
    .join("&");
  return `${baseUrl}/billing-api/bills/search?${searchString}`;
};

export const postBillLastPeriodRoute = (date) =>
  [billsBaseUrl, "bills", "last", `period?onDate=${encodeURIComponent(date)}`].join("/");

export const postBillPeriodRoute = (dateTo) =>
  [billsBaseUrl, `postbill?periodTo=${encodeURIComponent(dateTo)}&excludeBillPeriods=${1000}`].join(
    "/"
  );

export const createPostBillPeriodRoute = ({
  agreementId,
  filtredInvoiceIds,
  periodTo,
  onDate,
  transactionIds,
}) => {
  const filtredInvoiceIdsString = filtredInvoiceIds
    ?.map((invoiceId) => `filtredInvoiceIds=${invoiceId}`)
    .join("&");

  const filtredTransactionIdsString = transactionIds
    ?.map((chargeId) => `transactionIds=${chargeId}`)
    .join("&");
  const argString = [
    `periodTo=${encodeURIComponent(periodTo)}`,
    `onDate=${encodeURIComponent(onDate)}`,
    filtredInvoiceIdsString,
    filtredTransactionIdsString,
  ].join("&");
  return `${billsBaseUrl}/postbill/${agreementId}?${argString}`;
  // return {
  //   route: `${baseUrl}/billing-api/postbill/${agreementId}`,
  //   string: argString,
  // };
};

export const changeBillStatusRoute = ({ billId, billStatusId, reason }) =>
  buildUrl({
    url: `${billsBaseUrl}/bills/${billId}/status`,
    searchParams: {
      billStatusId,
      reason,
    },
  });
